import Axios from "axios";
import * as React from "react";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Redirect, NavLink } from "react-router-dom";
import config from "../../config";
import { IHolder } from "../../interfaces";
import CoreComponent from "../CoreComponent";

declare global {
    interface Window {
        am4core: any;
        am4themes_animated: any;
        am4charts: any,
        am4themes_dark: any
    }
}

interface IState {
    holder: IHolder,
    isLoading: boolean,
    isStatLoading: boolean,
    isMOLoading: boolean,
    statistics: {
        month: number,
        currency: number
    }[],
    statYear: number,
    myObjects: {
        views: number,
        videos: number,
        musics: number,
        downloads: number
    },
    MOYear: number
}

class Main extends CoreComponent<any, IState> {

    state: IState = {
        holder: null,
        isLoading: false,
        isStatLoading: false,
        isMOLoading: false,
        statistics: [],
        statYear: undefined,
        myObjects: {
            views: 0,
            videos: 0,
            musics: 0,
            downloads: 0
        },
        MOYear: undefined
    }

    async componentWillMount() {
        this.loadBalance();
        this.loadStatistics();
        this.loadMyObjects();
    }

    async loadBalance() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/transactions/current-balance`;

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    holder: res.data.user,
                    isLoading: false
                })
            }
        })
    }

    async loadMyObjects() {
        this.setState({
            isMOLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/composition/my-objects`;

            if (this.state.MOYear) {
                url += `?year=${this.state.MOYear}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    myObjects: res.data.data,
                    MOYear: res.data.year,
                    isMOLoading: false
                });
            }
        });
    }

    async loadStatistics() {
        this.setState({
            isStatLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/transactions/statistics`;

            if (this.state.statYear) {
                url += `?year=${this.state.statYear}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    statYear: res.data.year,
                    isStatLoading: false,
                    statistics: res.data.doxods
                }, () => {
                    this.initChart();
                })
            }
        })
    }

    componentDidMount() {

    }

    initChart() {
        let _this = this;


        window.am4core.ready(function () {
            // Themes begin
            window.am4core.useTheme(window.am4themes_animated);
            window.am4core.useTheme(window.am4themes_dark);
            // Themes end

            var chart = window.am4core.create('chartdiv', window.am4charts.XYChart);

            chart.data = _this.state.statistics;
            chart.responsive.enabled = false;
            chart.paddingLeft = 0;
            chart.paddingRight = 0;

            var categoryAxis = chart.xAxes.push(new window.am4charts.CategoryAxis());
            categoryAxis.renderer.minGridDistance = 5;
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.ticks.template.disabled = true;
            categoryAxis.renderer.line.opacity = 0;
            categoryAxis.renderer.grid.template.disabled = true;
            categoryAxis.dataFields.category = 'month';
            categoryAxis.startLocation = 0.4;
            categoryAxis.endLocation = 0.6;
            categoryAxis.renderer.labels.template.fontSize = 9;
            categoryAxis.renderer.labels.template.fill = window.am4core.color("#9698a0");

            function createAxisAndSeries(field: any, name: any, opposite: any) {
                var valueAxis = chart.yAxes.push(new window.am4charts.ValueAxis());
                valueAxis.tooltip.disabled = true;
                valueAxis.renderer.line.opacity = 0;
                valueAxis.renderer.ticks.template.disabled = true;
                valueAxis.renderer.labels.template.fontSize = 9;
                valueAxis.renderer.labels.template.fill = window.am4core.color("#9698a0");
                valueAxis.numberFormatter = new window.am4core.NumberFormatter();
                valueAxis.numberFormatter.numberFormat = field == "currency" ? "$#" : "#a";
                valueAxis.min = 0;
                valueAxis.renderer.minGridDistance = 50;
                valueAxis.renderer.grid.template.location = 0.5;
                valueAxis.startLocation = 0.5;
                valueAxis.endLocation = 0.5;

                if (chart.yAxes.indexOf(valueAxis) != 0) {
                    valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
                }

                var lineSeries = chart.series.push(new window.am4charts.LineSeries());
                lineSeries.dataFields.categoryX = 'month';
                lineSeries.dataFields.valueY = field;
                // lineSeries.tooltipHTML = field == "currency" ? 'Доход за {categoryX}: <span style="color: #EF225D">${valueY.value.numberFormat("#.")}</span>' : 'Просмотры за {categoryX}: <span style="color: #EF225D">{valueY.value}</span>';
                lineSeries.tooltip.getFillFromObject = false;
                lineSeries.tooltip.background.fill = window.am4core.color("#FFF");
                lineSeries.tooltip.autoTextColor = false;
                lineSeries.tooltip.label.fill = window.am4core.color("#1A1D2C");
                lineSeries.adapter.add('tooltipHTML', (text: any, target: any) => {
                    let data = target.tooltipDataItem.dataContext;
                   
                    return field == 'currency' ? `Доход за ${data.month}: <span style="color: #EF225D; font-family: Arial">$${data.currency.replace(',', ' ').replace(".", ",")}</span>` : `Просмотры за ${data.month}: <span style="color: #EF225D; font-family: Arial">${data.views.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</span>`;
                });

                let gradient = new window.am4core.LinearGradient();
                gradient.rotation = 90;
                gradient.addColor(window.am4core.color("rgba(239, 34, 93, 0)"));
                gradient.addColor(window.am4core.color("rgba(239, 34, 93, 0.5)"));

                lineSeries.fillOpacity = 1;
                lineSeries.fill = gradient;

                lineSeries.strokeWidth = 1;
                lineSeries.stroke = '#EF225D';
                lineSeries.propertyFields.stroke = '#642C48';
                lineSeries.propertyFields.fill = '#642C48';
                lineSeries.tensionX = 0.77;
                lineSeries.yAxis = valueAxis;
                lineSeries.name = name;
                lineSeries.showOnInit = true;

                var bullet = lineSeries.bullets.push(new window.am4charts.CircleBullet());
                bullet.circle.radius = 7;
                bullet.circle.fill = window.am4core.color('#EF225D');
                bullet.circle.strokeWidth = 3;
                bullet.circle.stroke = window.am4core.color('#FFF');
                bullet.fillOpacity = 0;
                bullet.strokeOpacity = 0;

                var bulletState = bullet.states.create("hover");
                bulletState.properties.fillOpacity = 1;
                bulletState.properties.strokeOpacity = 1;


                valueAxis.renderer.opposite = opposite;
            }

            createAxisAndSeries("currency", "Currency", false);
            createAxisAndSeries("views", "Views", true);

            chart.cursor = new window.am4charts.XYCursor();
            chart.cursor.behavior = 'panX';
            chart.cursor.lineX.opacity = 0;
            chart.cursor.lineY.opacity = 0;
        });
    }

    years() {
        let years = [];

        for (let i = 2019; i <= new Date().getFullYear(); i++) {
            years.push(<option value={i} key={i}>{i}</option>);
        }

        return years;
    }

    render() {
        let { auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="riz-mobi__graph">
                <div className="wrapper">
                    <div className="riz-mobi__graph-content">
                        <div className="riz-mobi__graph-cover mb-5">
                            <div className="riz-mobi__graph-logo">
                                <img src="img/rizanova-bank.png" alt="" />
                            </div>
                            <span className="riz-mobi__title riz-mobi__title-fs" >Баланс</span>
                        </div>
                        <div className="riz-mobi__graph-cover mb-0">
                            <div className="riz-mobi__artist">
                                <div className="riz-mobi__artist-name">
                                    <span dangerouslySetInnerHTML={{
                                        __html: auth?.user?.full_name.replace(" ", "<br/>")
                                    }}></span>
                                </div>
                                {auth?.user?.card && <div className="riz-mobi__artist-id">{auth?.user?.card}</div>}
                            </div>
                            <div className="riz-mobi__artist-price align-self-end">
                                <span className="tit">Доступно</span>
                                <span className={"prc mb-0 " + (Number.parseFloat(this.state.holder?.balance) > 0 ? "text-green" : "")}>$ {this.state.holder && Number.parseFloat(this.state.holder?.balance.toString()).toFixed(3).slice(0, -1)}</span>
                                {/* <span className="tit">В ожидании</span>
                                <span className="prc">$ {this.state.holder && Number.parseFloat(this.state.holder?.waiting.toString()).toFixed(3).slice(0, -1)}</span> */}
                            </div>
                        </div>
                        <span className="graph__bg">
                            <img src="img/graph-bg.png" alt="" />
                        </span>
                    </div>
                    <div className="riz-mobi__graph-content">
                        <div className="riz-mobi__graph-cover">
                            <div className="left-top-block">
                                <span>Год:</span>
                                <select name="years" id="years" value={this.state.statYear} onChange={(e: any) => {
                                    this.setState({ statYear: Number.parseInt(e.target.value) }, () => {
                                        this.loadStatistics();
                                    });
                                }}>
                                    {this.years()}
                                </select>
                            </div>
                            <span className="riz-mobi__title fs-24">Статистика</span>
                        </div>
                        <div className="riz-mobi__graph-cover" style={{ margin: "0 -15px" }}>
                            <div id="chartdiv"></div>
                        </div>

                    </div>
                    <div className="riz-mobi__graph-content mb-2">
                        <div className="riz-mobi__graph-cover">
                            <div className="left-top-block">
                                {/* <span>Год:</span>
                                <select name="moyears" id="moyears" value={this.state.MOYear} onChange={(e: any) => {
                                    this.setState({ MOYear: Number.parseInt(e.target.value) }, () => {
                                        this.loadMyObjects();
                                    });
                                }}>
                                    {this.years()}
                                </select> */}
                            </div>
                            <span className="riz-mobi__title fs-24">Объекты</span>
                        </div>
                        <div className="riz-mobi__graph-cover flex-direction-column">
                            <div className="d-flex w-100">
                                <div className="w-50">
                                    <span className="riz-mobi__count-title">Аудио</span>
                                    <div className="riz-mobi__counts">
                                        <div className="riz-mobi__count">
                                            <span className="riz-mobi__count-subtitle">Кол-во</span>
                                            <span className="riz-mobi__count-int">{this.state.myObjects?.musics}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-50">

                                    <span className="riz-mobi__count-title">Видео</span>
                                    <div className="riz-mobi__counts">
                                        <div className="riz-mobi__count">
                                            <span className="riz-mobi__count-subtitle">Кол-во</span>
                                            <span className="riz-mobi__count-int">{this.state.myObjects?.videos}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <span className="graph__bg">
                            <img src="img/graph-bg.png" alt="" />
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(Main);